import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { Box, Button, Container, Typography } from '@mui/material';
import { Title } from '../Component/Title';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { i18nContext } from '../i18n/i18nContext';
import { HeldTimesContext } from '../Root/CompetitionRoot';
import { KaguRefDataType } from "./KaguRefForm";
import dayjs from 'dayjs';

/**
 * 登録情報表示画面
 */
export function KaguRefInfo({kaguRefData}:{kaguRefData:KaguRefDataType | undefined}) {

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    const ItemSize = 4
    const ValueSize = 8

    return(
        <>
            <Box>
                <Title>
                    {t("KaguRefInfo.Title1", heldTimesOption)}
                </Title>
            </Box>

            <Container maxWidth="md">
                <Typography
                    variant='h6'
                    sx={{
                        textAlign:"left",
                        mt:2
                    }}
                >
                    {t("KaguRefInfo.Item1")}
                </Typography>
                <Grid2 container spacing={1} mt={1}>
                    {/* メールアドレス */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguRefInfo.MailAddress")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.mailaddress}
                    </Grid2>
                    {/* 氏名 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguRefInfo.Name")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.poster}
                    </Grid2>
                    {/* 国・地域 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguRefInfo.Country")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.country_name}
                    </Grid2>
                    {/* 生年月日 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguRefInfo.Birthday")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {lng === "ja" ? dayjs(kaguRefData?.birthday).format("YYYY/MM/DD") : dayjs(kaguRefData?.birthday).format("MM/DD/YYYY")}
                    </Grid2>
                    {/* 教育機関 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguRefInfo.Educational")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.educational_institution}
                    </Grid2>
                    {/* 国・地域(教育機関) */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                        {t("KaguRefInfo.EducationalCountry")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.educational_institution_country_name}
                    </Grid2>
                    {/* 代表者の在籍証明 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                        {t("KaguRefInfo.MainCertificate")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {kaguRefData?.proof_file_name}
                    </Grid2>
                </Grid2>

                {/* グループ情報 */}
                {kaguRefData?.group_flg ?
                    <Box>
                        <Typography
                            variant='h6'
                            sx={{
                                textAlign:"left",
                                mt:3
                            }}
                        >
                            {t("KaguRefInfo.Item2")}
                        </Typography>

                        {kaguRefData?.group_info?.map((value, index) => (
                            <Box key={value.group_id} mt={2}>
                                <Grid2 container spacing={1} mt={1} key={value.group_id}>
                                    {/* メンバー番号 */}
                                    <Grid2 xs={12} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguRefInfo.Member")}{index + 1}
                                    </Grid2>
                                    {/* 氏名 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguRefInfo.Name")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.poster}
                                    </Grid2>
                                    {/* 国・地域 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguRefInfo.Country")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.country_name}
                                    </Grid2>
                                    {/* 生年月日 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguRefInfo.Birthday")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {lng === "ja" ? dayjs(value?.birthday).format("YYYY/MM/DD") : dayjs(value?.birthday).format("MM/DD/YYYY")}
                                    </Grid2>
                                    {/* 教育機関 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguRefInfo.Educational")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.educational_institution}
                                    </Grid2>
                                    {/* 国・地域(教育機関) */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                                        {t("KaguRefInfo.EducationalCountry")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.educational_institution_country_name}
                                    </Grid2>
                                    {/* 在籍証明 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                                        {t("KaguRefInfo.MemberCertificate")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.proof_file_name}
                                    </Grid2>
                                </Grid2>
                            </Box>
                        ))}
                    </Box>
                :""}

                {/* 作品ファイル */}
                <Box>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign:"left",
                            mt:2
                        }}
                    >
                        {t("KaguRefInfo.Item3")}
                    </Typography>
                    <Grid2 container spacing={1} mt={2}>
                        {/* 作品ファイル名 */}
                        <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {t("KaguRefInfo.WorkFile")}
                        </Grid2>
                        <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {kaguRefData?.artwork_file_name}
                        </Grid2>                        
                        {/* 作品製品化の興味 */}
                        <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                            {t("KaguRefInfo.Product")}
                        </Grid2>
                        <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {kaguRefData?.interest_work ? t("KaguRefInfo.Yes") : t("KaguRefInfo.No")}                 
                        </Grid2>
                    </Grid2>
                </Box>

                <Grid2 container spacing={1} mt={2} mb={2}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => setPage(PageNames.KaguRefForm)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Container>   
        </>
    );
}